export const routes = [
  {
    path: '/v-custom-benetton',
    name: 'Modulo benetton',
    component: () => import(/* webpackChunkName: "benetton" */ '../views/custom/benetton')
  },
  {
    path: '/v-custom-ottici',
    name: 'Modulo ottici',
    component: () => import(/* webpackChunkName: "ottici" */ '../views/custom/ottici')
  },
  {
    path: '/v-custom-esterni',
    name: 'Modulo esterni',
    component: () => import(/* webpackChunkName: "esterni" */ '../views/custom/esterni')
  },
  {
    path: '/v-custom-tabacchi',
    name: 'Modulo tabacchi',
    component: () => import(/* webpackChunkName: "tabacchi" */ '../views/custom/tabacchi')
  },
  {
    path: '/v-custom-scala-taglie/prodotti',
    name: 'Modulo scala taglie prodotti',
    component: () => import(/* webpackChunkName: "scalaTaglieProdotti" */ '../views/custom/scalaTaglie/elementi/prodotti')
  },  
  {
    path: '/v-custom-scala-taglie',
    name: 'Modulo scala taglie',
    component: () => import(/* webpackChunkName: "scalaTaglieGestione" */ '../views/custom/scalaTaglie')
  },
  {
    path: '/v-custom-offerte',
    name: 'Modulo offerte',
    component: () => import(/* webpackChunkName: "offerte" */ '../views/offerte')
  },
  {
    path: '/v-custom-bilance',
    name: 'Modulo bilance',
    component: () => import(/* webpackChunkName: "bilance" */ '../views/custom/bilance')
  }
]